<template>
    <div class="element" :data-required="this.required" :class="{ [this.type] : true, error : error.error }">
        <labelElement v-bind="resolveProps('label', this)" :error="error" />

        <input
            :type="(!this.editing || this.readonly) ? 'text' : 'hidden'"
            :name="this.name"
            class="input"
            v-model="input"
            :readonly="!this.editing || this.readonly"
            :aria-describedby="error.error ? `error_${this.id}` : null"
        />
        <Calendar
            v-if="!(!this.editing || this.readonly)"
            :id="`field_${this.id}`"
            v-model="calendarInput"
            dateFormat="HH:mm"
            hourFormat="24"
            :touchUI="false"
            :timeOnly="true"
            />

        <errorElement v-bind="resolveProps('error', this)" :error="error" :errorId="`error_${this.id}`" />
        <tooltipElement v-bind="resolveProps('tooltip', this)" :inline="true" />
    </div>
</template>

<script>
import {ref, watch} from "vue";

// Our form helpers
import useFieldValidation from "formbuilder/fields/_validation";
import { propDefaults, resolveProps } from "formbuilder/fields/_props";

// Our helpers
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

// Our external components
import Calendar from 'primevue/calendar';

import labelElement from "formbuilder/elements/LabelElement.vue";
import stateElement from "formbuilder/elements/StateElement.vue";
import placeholderElement from "formbuilder/elements/PlaceholderElement.vue";
import errorElement from "formbuilder/elements/ErrorElement.vue";
import tooltipElement from "formbuilder/elements/TooltipElement.vue";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        Calendar,
        labelElement,
        stateElement,
        placeholderElement,
        errorElement,
        tooltipElement
    },
    setup(props, { emit }) {
        const input = ref("");
        const calendarInput = ref("");
        const {registerValidator, validate, error} = useFieldValidation();
        registerValidator(input, props);

        // const formatTime = (value) => {
        //     const date = new Date(value);
        //     const hours = date.getHours().toString().padStart(2, '0');
        //     const minutes = date.getMinutes().toString().padStart(2, '0');
        //     const formattedTime = `${hours}:${minutes}`;
        //     return formattedTime;
        // }

        watch(
            () => calendarInput.value,
            (value) => {
                input.value = value ? value : "";
            }
        )

        watch(
            () => props.value,
            () => {
                input.value = props.value;
                calendarInput.value = props.value ? new Date(props.value) : "";
            },
            {
                immediate: true
            }
        );
        watch(
            () => input.value,
            validate
        );

        // If we got a initial value, validate instantly
        props.value && validate();

        return {
            trans,
            input,
            calendarInput,
            error,
            resolveProps
        };
    },
}
</script>

<style lang="scss">
    .p-datepicker {
        background: #fff;
        box-shadow: 3px 3px 10px rgba(#000,0.3);
        padding: 10px;

        button {
            border:0; background:none transparent; font-weight:bold; color:inherit;
        }

        .p-datepicker-calendar th {
            text-align:center; text-transform:lowercase;
            padding:5px 0;
        }

        .p-disabled {
            opacity:0.5;
            pointer-events:none;
        }
        .p-datepicker-decade {
            font-weight:bold;
        }
        .p-yearpicker-year, .p-monthpicker-month, .p-datepicker-calendar td > span {
            padding:5px;
        }
        .p-link {
            padding:10px;
        }
        .p-highlight {
            font-weight:bold;
        }

        .p-hour-picker, .p-minute-picker, .p-seperator {
            > span {
                font-size:1.11rem; font-weight:bold;
            }
        }
        .p-timepicker .p-link {
            font-size:10px; font-weight:normal;
        }
    }
</style>